/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_td_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare two texts`)
};

const es_td_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar dos textos`)
};

const de_td_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleiche zwei Texte`)
};

const nl_td_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergelijk twee teksten`)
};

const fr_td_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparer deux textes`)
};

const it_td_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta due testi`)
};

const pt_br2_td_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare dois textos`)
};

const pt_td_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar dois textos`)
};

const ja_td_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つのテキストを比較`)
};

const zh_td_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比较两段文本`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const td_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.td_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("td_nav_main_desc", locale)
	if (locale === "en") return en_td_nav_main_desc(inputs)
	if (locale === "es") return es_td_nav_main_desc(inputs)
	if (locale === "de") return de_td_nav_main_desc(inputs)
	if (locale === "nl") return nl_td_nav_main_desc(inputs)
	if (locale === "fr") return fr_td_nav_main_desc(inputs)
	if (locale === "it") return it_td_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_td_nav_main_desc(inputs)
	if (locale === "pt") return pt_td_nav_main_desc(inputs)
	if (locale === "ja") return ja_td_nav_main_desc(inputs)
	return zh_td_nav_main_desc(inputs)
};